var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-center justify-center p-8"},[_c('div',{staticClass:"flex items-center gap-2 text-center"},[_c('ChLoadingSpinner'),_vm._v(" "),(_vm.message)?_c('span',{staticClass:"text-sm leading-[22px] font-normal text-gray-gray-17 dark:text-gray-gray-9"},[_vm._v("\n      "+_vm._s(_vm.message)+"\n    ")]):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }